import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import propTypes from 'prop-types';

const NavigationButtons = ({
  type, onClick, text, className, color,
}) => (
  <Button type={type} size="small" onClick={onClick}>
    <Text type="b200" color={color}>
      <span className={className}>
        <FormattedMessage id={text} />
      </span>
    </Text>
  </Button>
);
NavigationButtons.propTypes = {
  type: propTypes.string.isRequired,
  onClick: propTypes.func.isRequired,
  text: propTypes.string.isRequired,
  color: propTypes.string.isRequired,
  className: propTypes.string.isRequired,
};
export default NavigationButtons;
